const theme = {
	colorScheme: "dark",
	primaryColor: "orange",
}

export default theme
